import { render } from "./Listcom.vue?vue&type=template&id=3c18a5d6&scoped=true&lang=true"
import script from "./Listcom.vue?vue&type=script&lang=js"
export * from "./Listcom.vue?vue&type=script&lang=js"

import "./Listcom.vue?vue&type=style&index=0&id=3c18a5d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c18a5d6"]])

export default __exports__